import { Container } from './styles'

import reactIcon from '../../assets/react-icon.svg'
import linkedinIcon from '../../assets/linkedin.png'
import githubIcon from '../../assets/github.png'
import instagramIcon from '../../assets/instagram.png'


export function Footer() {
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>Yunes</span>
        <span>Nicolas</span>
      </a>
      <div>
        <p>
          Sitio diseñado con  <span>React</span><img src={reactIcon} alt="React" /> 
         
        </p>
      </div>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/nicolas-yunes-a38590117/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedinIcon} alt="LinkedIn" />
        </a>

        <a
          href="https://github.com/nicolasyunes"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>

        <a
          href="https://www.instagram.com/yunesnicolas/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>

      </div>
    </Container>
  )
}
